import React from "react";
import { useDispatch, useSelector } from "react-redux";

import ShareWorkspace from "../../MyWorkspace/ShareWorkspace";
import WorkspaceSettings from "../../MyWorkspace/WorkspaceSettings";

import { closePopup } from "../../../store/actions";

const AppPopups = () => {
  const openAppDrawer = useSelector((state) => state.openAppDrawer);
  const dispatch = useDispatch();

  return (
    <>
      {openAppDrawer?.workspaceShare && (
        <ShareWorkspace setOpen={(flag) => dispatch(closePopup({ workspaceShare: flag }))} />
      )}

      {openAppDrawer?.workspaceSetting && (
        <WorkspaceSettings setOpen={(flag) => dispatch(closePopup({ workspaceSetting: flag }))} />
      )}
    </>
  );
};

export default React.memo(AppPopups);
